import classNames from 'classnames';

const AVATAR_COLORS = [
  '#3B7BC0',
  '#C0444C',
  '#2E8B6E',
  '#7A4FB0',
  '#C9822B',
  '#5B6B78',
  '#B5487E',
  '#2F8C9E',
];

interface IAvatarProps {
  name: string;
  colorIndex: number;
  className: string;
}

export default function Avatar({ name, colorIndex, className }: IAvatarProps) {
  return (
    <span
      aria-hidden="true"
      className={classNames(
        'flex shrink-0 items-center justify-center rounded-full font-bold text-white',
        className
      )}
      style={{
        backgroundColor: AVATAR_COLORS[colorIndex % AVATAR_COLORS.length],
      }}
    >
      {Array.from(name)[0]?.toUpperCase()}
    </span>
  );
}

export function BotIcon({ size = 18 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <rect x="4" y="8" width="16" height="12" rx="3" />
      <path d="M12 4v4M9 13v1.5M15 13v1.5" />
    </svg>
  );
}

export function CrownIcon({
  size = 26,
  className,
}: {
  size?: number;
  className?: string;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      aria-hidden="true"
      className={className}
    >
      <path
        fill="currentColor"
        d="M3 8.5l4.5 3.5L12 5l4.5 7L21 8.5 19 19H5L3 8.5z"
      />
    </svg>
  );
}
